export default "__VITE_ASSET__4f4fc558__"